import { render, staticRenderFns } from "./CeurComingSoon.vue?vue&type=template&id=4dec5308"
import script from "./CeurComingSoon.vue?vue&type=script&lang=js"
export * from "./CeurComingSoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports